import { hoistStatics, mapProps } from 'recompose';

const NAVIGATION_KEYS = [
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
  'PageUp',
  'PageDown',
];

export default hoistStatics(mapProps(
  props => ({
    ...props,
    input: {
      ...props.input,
      onKeyDown: (e) => {
        if (NAVIGATION_KEYS.includes(e.key)) {
          e.preventDefault();
          if (props.input.value && props.input.value.length > 0) {
            e.target.focus();
            e.target.setSelectionRange(0, props.input.value.length);
          }
        }
      },
      onMouseDown: (e) => {
        e.preventDefault();
        e.target.focus();
        if (props.input.value && props.input.value.length > 0) {
          e.target.setSelectionRange(0, props.input.value.length);
        }
      },
      onFocus: (e) => {
        if (props.input.value && props.input.value.length > 0) {
          e.target.focus();
          e.target.setSelectionRange(0, props.input.value.length);
        }
      },
    },
  }),
));
